module.exports = __webpack_public_path__ + "img/martini-glas.c1c06b5d.png";